import EventBus from 'src/components/EventBus.js'
var LoadUser = {
  created() {
    EventBus.$on('user-fetched', this.assignData);
  },
  beforeDestroy() {
    EventBus.$off('user-fetched', this.assignData);
  }
}

export default LoadUser;
